module.exports = __webpack_public_path__ + "img/shield.9d0a6ec2.svg";